<template>
  <div class="content">
      <iframe :src="srcs" class="iframe-sty" :style="height"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return { 
     srcs: '',
     winHeight: window.innerHeight,
      height: {
        height: '',
      },
      userId:'',
      token:'',
    };
  },
  created() {  
    this.src = ''; 
    // this.getSrc();
    this.getToken();

    // var myDate = new Date();
    //     var month = myDate.getMonth() + 1;
    //     var strDate = myDate.getDate();
    //     if (month >= 1 && month <= 9) {
    //         month = "0" + month;
    //     }
    //     if (strDate >= 0 && strDate <= 9) {
    //         strDate = "0" + strDate;
    //     }
    //   var currentDate = myDate.getFullYear() + "-" + month + "-" + strDate + " 23:59:59"; 
    //   var timestamps = Date.parse(currentDate)/1000;
    //  console.log("今天晚上",timestamps);

    //     var timestamps1 = Date.parse(new Date())/1000; 
    //   console.log("当前时间",timestamps1);
      
    //   var expiresTime = localStorage.getItem("expiresTime");
    //   if (localStorage.getItem("wynToken") == null) { 
    //           this.loginWyn();
    //     }else{
    //           var time = Math.round(parseFloat(timestamps) - parseFloat(expiresTime)); 
    //           console.log(time);
    //           if(time == 0){
    //                 this.loginWyn();
    //           }
    //     }
    // window.location.href = process.env.FGBH5Api + 'index?appKey=' + process.env.sitappkey + '&' + self.toQueryString(data);
    // this.src = 'http://49.4.23.228:31980/reports/view/0ddb33e9-3211-4d96-9d25-ca34458dd8b9?display=singlepage&size=fitwidth&parampanel=top&theme=green&lng=zh&token=670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef'
  },   
  watch: { 
    $route(to, from) { 
       this.getSrc(); 
    },
  },
  mounted(){    
    this.getSrc(); 
    window.onresize = () => { 
            return (() => { 
            this.winHeight = window.innerHeight 
                })
            } 
            this.height.height=this.winHeight-170+'px' 
  }, 
  methods: {
    getToken() {
      let self = this;  
      self.api.get('/ms-data-business-service/wyn/token/get-dynamic/10').then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.token = res.data.data;
          self.getIdCode(); 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },  
    getIdCode() {
      let self = this;  
      console.log(self.$router.history.current.query.idCard);
      let idCode = self.$router.history.current.query.idCard;
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/user/data/get`,{'idCode':idCode}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          if(res.data.data.records != null){
              let userId = [];
              let month = [];
              userId.push(res.data.data.records[0].guid);
              month.push(self.$router.history.current.query.month);
              let dp = {
                  "month":month,
                  "user":userId
              }
              let str = JSON.stringify(dp); 
              console.log(str,encodeURIComponent(str));
              self.srcs = 'https://bi.csbr.cn/reports/view/653c6b77-3f9a-44d7-b76b-9b27fd9495b2?display=singlepage&parampanel=top&token=' + self.token + '&dp='+ encodeURIComponent(str); 
              console.log(self.srcs);
          } 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
     getAuthorization(){
        var auth = 'Basic ' + window.btoa('integration' + ':' + 'eunGKas3Pqd6FMwx9eUpdS7xmz');
        //alert(auth);
        return auth;
      },
      loginWyn(){
        var loginUrl = 'https://bi.csbr.cn/api/generatetoken?token=670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef';
        var userName = 'admin';
        var password = 'csbr!1234';
        var myDate = new Date();
        var month = myDate.getMonth() + 1;
        var strDate = myDate.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentDate = myDate.getFullYear() + "-" + month + "-" + strDate;
        var bo = {ExpireIn:currentDate + " 16:00:00",User:userName,Password:password,OrganizationPath:"/"};
        fetch(loginUrl, {
                  method: "POST",
                  headers: {
                      "Content-type": "application/json",
                      // "Authorization": this.getAuthorization()
                  },
                  // body: "grant_type=password&username=" + userName + "&password=" + password + "&OrganizationPath='/'"
                  body:JSON.stringify(bo)
              }
        )
        .then(function (res) { return res.json(); }) .then(function (res) {
             var token = res.access_token;
           })
      },
      // loginWyn(){
      //   var loginUrl = 'https://bi.csbr.cn/connect/token';
      //   var userName = 'admin';
      //   var password = 'csbr!1234';
      //   fetch(loginUrl, {
      //             method: "POST",
      //             headers: {
      //                 "Content-type": "application/x-www-form-urlencoded",
      //                 "Authorization": this.getAuthorization()
      //             },
      //             body: "grant_type=password&username=" + userName + "&password=" + password
      //         }
      //   )
      //   .then(function (res) { return res.json(); }) .then(function (res) {
      //        var token = res.access_token;
      //        alert(token);
      //      })
      // },
    getSrc(){ 
      let self = this;
        console.log('6565',this.$route.path); 
        let route =  this.$route.path;
        var wynToken = localStorage.getItem("wynToken");
        console.log(wynToken);
        if(localStorage.getItem("menuList")){  
           let menuList = JSON.parse(localStorage.getItem("menuList"));
           menuList.forEach(function(i) { 
                    if(i.children != null && i.children != ''){
                        i.children.forEach(function(j) {
                                    if(route == j.path){  
                                      self.srcs = j.src; 
                                    }
                               }) 
                    }else{  
                      if(route == i.path){ 
                        console.log("123",route,i.src);
                        self.srcs = i.src;
                      }
                    }
                })   
        }else{
          self.srcs = 'http://49.4.23.228:31980/reports/view/0ddb33e9-3211-4d96-9d25-ca34458dd8b9?display=singlepage&size=fitwidth&parampanel=top&theme=green&lng=zh&token=' + wynToken;
        }
        console.log('src',self.srcs);
    } 
  },
};
</script>
<style  scoped>
 .content {
  margin: 0px;
 }
 .iframe-sty{ 
  width:100%;
  border:none;
  background:grey;
 }
</style>